import React, { useState, useEffect, useCallback } from 'react';
import { Users, RefreshCw } from 'lucide-react';
import { claimsService, LeadClaim } from '@/services/claimsService';
import { useUser } from '@/contexts/UserContext';
import { showToast } from '@/components/ui/Toast';
import ClaimsTable from '../_Components/ClaimsTable';

const MineClaimsPage: React.FC = () => {
  const { userData } = useUser();
  const isSuperAdmin = userData?.data?.role?.role_id === 9401;

  const [claims, setClaims] = useState<LeadClaim[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchClaims = useCallback(async () => {
    setLoading(true);
    try {
      const res: any = await claimsService.getMyClaims();
      if (res.success) setClaims(res.data || []);
    } catch {
      showToast('Failed to fetch claims', 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchClaims(); }, [fetchClaims]);

  return (
    <div className="flex flex-col h-full">
      <div className="bg-white border-b px-6 py-4 flex items-center justify-between shrink-0">
        <div className="flex items-center gap-3">
          <Users className="h-5 w-5 text-brandColor" />
          <div>
            <h1 className="text-xl font-bold text-gray-900">My Claims</h1>
            <p className="text-xs text-gray-400">Your personal claim request history</p>
          </div>
        </div>
        <button
          onClick={fetchClaims}
          disabled={loading}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          Refresh
        </button>
      </div>

      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="p-6">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="animate-spin h-8 w-8 border-2 border-brandColor border-t-transparent rounded-full" />
            </div>
          ) : (
            <ClaimsTable claims={claims} mode="mine" isSuperAdmin={isSuperAdmin} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MineClaimsPage;
